<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2 v-if="!isAdminEffectifs">Consulter ou modifier les données d'effectifs soumises</h2>
        <h2 v-if="isAdminEffectifs">Consulter les données d'effectifs</h2>

        <b-col cols="12">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  label="Marché" label-for="input-marches"
                                  v-if="isAdmin">
                        <AutocompleteCustom
                            id="input-marcheIds"
                            :items="marcheIdsItems"
                            v-model="marcheId"
                            @search="onMarcheSearch"
                            :placeholder=libelles.selectionnerMarche
                            :clear=ligneId
                        >
                        </AutocompleteCustom>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-lignes"
                                  label="Ligne" label-for="input-lignes"
                                  v-if="isAdmin">
                        <b-form-select
                            id="input-lignes"
                            v-model="ligneId"
                            :options="lignes"
                            required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    Sélectionner une ligne
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="4" class="d-lg-flex justify-content-center align-items-center flex-wrap">
                    <b-button class="mt-2 mr-2" v-if="marcheId || ligneId" type="button" variant="success" @click="exporter">Exporter
                    </b-button>
                    <b-button class="mt-2 ml-2" v-show="isAdminEffectifs" type="button" variant="success" @click="openModal">
                        Exporter fichier heures cumulées
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-date-debut" label-for="input-date-debut">
                        <template v-slot:label>
                            <label-custom
                                label="Date de début">
                            </label-custom>
                        </template>
                        <vue-monthly-picker
                            id="input-date-debut"
                            dateFormat="MM/YYYY"
                            :monthLabels="monthLabels"
                            v-model="dateDebut"
                            @selected="search()"
                        >
                        </vue-monthly-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-date-fin" label-for="input-date-fin">
                        <template v-slot:label>
                            <label-custom
                                label="Date de fin">
                            </label-custom>
                        </template>
                        <vue-monthly-picker
                            id="input-date-fin"
                            dateFormat="MM/YYYY"
                            :monthLabels="monthLabels"
                            v-model="dateFin"
                            @selected="search()"
                        >
                        </vue-monthly-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-statuts"
                                  label="Statut" label-for="input-statuts">
                        <b-form-select
                            id="input-statuts"
                            v-model="statuts"
                            @change="search">
                            <b-form-select-option :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION']">
                                Valides et en attente
                            </b-form-select-option>
                            <b-form-select-option :value="['SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                Archivés
                            </b-form-select-option>
                            <b-form-select-option
                                :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION', 'SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                Tous
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

        </b-col>

        <div v-if="effectifInfosResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                            v-model="pageSize"
                            :options="pageSizes"
                            @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                            v-model="pageIndex"
                            :total-rows="effectifInfosResult.totalElements"
                            :per-page="pageSize"
                            :limit="10"
                            align="center"
                            @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="effectifInfosTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{ pageSize * (pageIndex - 1) + (row.index + 1) }}
                        </div>
                    </template>
                    <template v-slot:cell(cheminFichierJustificatif)="row">
                        <JustificatifButton :url="ENDPOINT_MARCHE_EFFECTIF_PIECE_JUSTIFICATIF" :row="row" />
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="consulterEffectifInfos(row.item.id)"
                                  v-if="row.item.statut !== 'VALIDE' || isRead">
                            <Icon icon="book-open" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm" @click="consulterEffectifInfos(row.item.id)"
                                  v-if="row.item.statut === 'VALIDE' && (!row.item.jourSoumissionPassed || isAdminEffectifs) && !isRead">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm"
                                  v-if="row.item.statut === 'VALIDE' && row.item.jourSoumissionPassed && !isAdminEffectifs && !isRead"
                                  v-b-modal="'modal-edit' + row.item.id">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-modal
                            :id="'modal-edit' + row.item.id"
                            title="Modification de données d'effectifs"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            @ok="consulterEffectifInfos(row.item.id)">
                            <p>{{ libelles.messageHorsPeriodeSoumission }}</p>
                        </b-modal>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id"
                                  v-if="row.item.statut !== 'ATTENTE_SUPPRESSION' && row.item.statut !== 'SUPPRIMEE' && row.item.statut !== 'ARCHIVEE'">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                            :id="'modal-delete' + row.item.id"
                            title="Suppression de données d'effectifs"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            @ok="supprimerEffectifInfos(row.item)">
                            <p>Confirmez-vous la suppression de ces données d'effectifs ?</p>
                            <p v-if="row.item.statut === 'VALIDE'">
                                La suppression de ces données d'effectifs entrainera la suppression des modifications en
                                attente associées.
                            </p>
                            <p v-if="row.item.jourSoumissionPassed && !isAdminEffectifs && row.item.statut === 'VALIDE'">
                                {{ libelles.messageHorsPeriodeSoumission }}
                            </p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal id="export-heure" title="Choisir les dates d'export des heures cumulées">
            <div>
                <b-form-group id="input-group-date-debut" label-for="input-date-debut">
                    <template v-slot:label>
                        <label-custom
                            label="Date de début">
                        </label-custom>
                    </template>
                    <vue-monthly-picker
                        id="input-date-debut"
                        dateFormat="MM/YYYY"
                        :monthLabels="monthLabels"
                        v-model="exportHour.startDate"
                    >
                    </vue-monthly-picker>
                </b-form-group>
                <b-form-group id="input-group-date-fin" label-for="input-date-fin">
                    <template v-slot:label>
                        <label-custom
                            label="Date de fin">
                        </label-custom>
                    </template>
                    <vue-monthly-picker
                        id="input-date-fin"
                        dateFormat="MM/YYYY"
                        :monthLabels="monthLabels"
                        v-model="exportHour.endDate"
                    >
                    </vue-monthly-picker>
                </b-form-group>
            </div>

            <template #modal-footer>
                <div>
                    <b-button @click="$bvModal.hide('export-heure')">Annuler</b-button>
                    <b-button @click="exportHeure" variant="primary" class="ml-4">Exporter</b-button>
                </div>
            </template>
        </b-modal>

    </div>
</template>

<script>

import MarcheEffectifInfosStore from "../../stores/MarcheEffectifInfosStore";
import AlertStore from "../../stores/AlertStore";
import MarcheStore from "../../stores/MarcheStore";
import LigneStore from "../../stores/LigneStore";
import SessionStore from '@/stores/SessionStore'
import hasPermission from "../../filters/hasPermission";
import {EventBus} from '@/event-bus'
import {StatutEnum} from "../../constants/enums";
import moment from 'moment';
import FileUtil from "../../utils/fileUtil";
import MarcheEffectifInfosDto from "../../dtos/MarcheEffectifInfosDto";
import {libelles} from '../../constants/libelles';
import VueMonthlyPicker from "vue-monthly-picker";
import {mois} from "../../constants/enums";
import LabelCustom from "../../components/LabelCustom";
import {momentToDate} from "../../utils/dateUtil";
import AutocompleteCustom from "../../components/AutocompleteCustom";
import {BModal, BFormGroup, BButton} from "bootstrap-vue";
import {ENDPOINT_MARCHE_EFFECTIF_PIECE_JUSTIFICATIF} from "../../constants/endpoints";
import JustificatifButton from "@/components/utils/JustificatifButton.vue";


export default {
    components: {
        JustificatifButton,
        VueMonthlyPicker,
        BModal,
        BButton,
        BFormGroup,
        LabelCustom,
        AutocompleteCustom
    },
    data() {
        return {
            sessionStoreState: SessionStore.state,
            marcheId: null,
            ligneId: null,
            marches: [],
            exportHour: {
                endDate: null,
                startDate: null
            },
            lignes: [],
            statuts: ['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION'],
            effectifInfosResult: null,
            pageSize: null,
            pageSizes: [10, 25, 50, 100],
            pageIndex: null,
            sortOptions: null,
            libelles: libelles,
            dateDebut: null,
            dateFin: null,
            monthLabels: mois,
            marcheIdsItems: [],
            ENDPOINT_MARCHE_EFFECTIF_PIECE_JUSTIFICATIF
        }
    },
    computed: {
        isAdminEffectifs() {
            return hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR']);
        },
        isAdmin() {
            return this.isAdminEffectifs && !this.sessionStoreState.marches.length;
        },
        isRead() {
            return hasPermission(['CORRESPONDANT_EFFECTIFS_LECTURE'])
        },
        fields() {
            const fields = [
                {label: '', key: 'num', sortable: false},
                {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
                {label: 'Données pour le mois', key: 'date', sortable: true},
                {label: 'Statut', key: 'statutLabel', sortable: false},
                {label: 'Consulter / Modifier', key: 'edit', sortable: false},
                {label: 'Supprimer', key: 'delete', sortable: false},
                {label: 'Piece Justificatif', key: 'cheminFichierJustificatif', sortable: false}
            ];
            if (this.isAdmin) {
                fields.splice(1, 0, {label: 'Marché', key: 'marche', sortable: true})
            }
            if (this.isRead) {
                fields.splice(fields.length - 1, 1)
            }
            return fields;
        },
        effectifInfosTable: function () {
            return this.effectifInfosResult.content.map(effectifInfos => {
                return {
                    id: effectifInfos.id,
                    date: moment(effectifInfos.date).format('MM/YYYY'),
                    marche: `${effectifInfos.marche.reference} (${effectifInfos.marche.libelleCourt})`,
                    statut: effectifInfos.statut,
                    statutLabel: StatutEnum[effectifInfos.statut],
                    jourSoumissionPassed: effectifInfos.jourSoumissionPassed,
                    modifiedDate: new Date(effectifInfos.modifiedDate).toLocaleDateString(),
                    cheminFichierJustificatif: effectifInfos.cheminFichierJustificatif
                }
            });
        }
    },
    watch: {
        marcheId(newMarcheId) {
            this.onMarcheSearch(newMarcheId, true);
            this.search();
        },
        ligneId(newLigneId) {
            if (newLigneId) {
                this.marcheId = null;
            }
            this.onMarcheSearch();
            this.search();
        },
    },
    mounted() {
        this.initPagination();
        if (this.isAdmin) {
            MarcheStore.getAll().then(marches => {
                this.marches = marches.map(marche => {
                    return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
                });
                this.marcheIdsItems = this.marches;
            });
            LigneStore.getAll().then(
                response => this.lignes = response.map(value => {
                    return {text: value.libelleLong, value: value.id};
                })
            );
            this.search();
        } else {
            this.marcheId = this.sessionStoreState.marche.id;
            EventBus.$on('NavBar-marcheChange', () => {
                this.marcheId = this.sessionStoreState.marche.id;
            });
        }
    },
    beforeDestroy() {
        if (!this.isAdmin) {
            EventBus.$off('NavBar-marcheChange');
        }
    },
    methods: {
        openModal() {
            this.$bvModal.show('export-heure')
        },
        exportHeure() {
            MarcheEffectifInfosStore.exportHeure({
                startDate: momentToDate(this.exportHour.startDate),
                endDate: momentToDate(this.exportHour.endDate)
            }).then(
                result => {
                    FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
                },
                error => AlertStore.pushError(error.response.data.message)
            )
        },
        initPagination() {
            this.pageSize = 10;
            this.pageIndex = 1;
            const sortBy = !this.isAdmin ? 'date' : 'marche';
            this.sortOptions = [{sortBy: sortBy, sortDirection: 'asc'}];
        },
        sort(sort) {
            this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
            this.search();
        },
        consulterEffectifInfos(id) {
            this.$router.push("/marche-effectif-infos/" + id);
        },
        supprimerEffectifInfos(effectifInfos) {
            MarcheEffectifInfosStore.delete(effectifInfos).then(() => {
                this.search();
            });
        },
        search() {
            const effectifInfos = this.getSearchEffectifs();
            MarcheEffectifInfosStore.search(effectifInfos, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
                result => {
                    this.effectifInfosResult = result.data;
                },
                error => AlertStore.pushError(error.response.data.message)
            )
        },
        exporter() {
            if (this.marcheId || this.ligneId) {
                const effectifInfos = this.getSearchEffectifs();
                MarcheEffectifInfosStore.export(effectifInfos).then(
                    result => {
                        FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
                    },
                    error => AlertStore.pushError(error.response.data.message)
                )
            }
        },
        getSearchEffectifs() {
            const effectifInfos = new MarcheEffectifInfosDto();
            effectifInfos.marche = this.marcheId;
            effectifInfos.ligneId = this.ligneId;
            effectifInfos.statut = this.statuts;
            effectifInfos.dateDebut = this.dateDebut ? momentToDate(this.dateDebut) : null;
            effectifInfos.dateFin = this.dateFin ? momentToDate(this.dateFin) : null;
            return effectifInfos;
        },
        onMarcheSearch(marche, isId) {
            if (marche) {
                this.ligneId = null;
            }
            this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
        }
    }
}
</script>

